// extracted by mini-css-extract-plugin
export default {"infoModalWrapper":"styles_infoModalWrapper__I1XjE","cardTypeBlock":"styles_cardTypeBlock__A83q-","cardType":"styles_cardType__rF-Y4","isActive":"styles_isActive__7g8Vl"};